import React from 'react'

const BigEditIcon = (props) => {
    return (
        <img src={props.selected ? "/assets/icons/big-edit.svg" : "/assets/icons/big-edit.svg"}
             alt="Edit"
             style={props.style}
        />
    )
}

export default BigEditIcon